/* istanbul ignore file */
import _ from 'underscore';
// @ts-ignore
import { constants } from '@bingads-webui/instrumentation';

// Only wrapped the essential fields for tracking.
export const wrapLogger = (instrumentation: any) => (instrumentation && _.isFunction(instrumentation.writeRawLog) ? {
  mark: (scenarioName: string) => {
    instrumentation.writeRawLog({
      logCategory: constants.LOGCATEGORY.PERFORMANCE,
      activityName: scenarioName,
      entryType: constants.ENTRYTYPE.MESSAGE,
    });
  },
  startProcess: (scenarioName: string) => {
    instrumentation.writeRawLog({
      logCategory: constants.LOGCATEGORY.PERFORMANCE,
      activityName: scenarioName,
      isMethodEnter: true,
      entryType: constants.ENTRYTYPE.MESSAGE,
    });
  },
  endProcess: (scenarioName: string) => {
    instrumentation.writeRawLog({
      logCategory: constants.LOGCATEGORY.PERFORMANCE,
      activityName: scenarioName,
      isMethodEnter: false,
      entryType: constants.ENTRYTYPE.MESSAGE,
    });
  },
  trace: (scenarioName: string, message: string) => {
    instrumentation.writeRawLog({
      logCategory: constants.LOGCATEGORY.TRACE,
      api: scenarioName,
      message,
      entryType: constants.ENTRYTYPE.MESSAGE,
    });
  },
  error: (scenarioName: string, message: string) => {
    instrumentation.writeRawLog({
      logCategory: constants.LOGCATEGORY.ERROR,
      api: scenarioName,
      message,
      entryType: constants.ENTRYTYPE.MESSAGE,
    });
  },
} : undefined);
